import {memo} from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';

interface IPlayButtonProps {
    onClick: () => void;
}

const PlayButton = memo<IPlayButtonProps>(({onClick}: IPlayButtonProps) => (
    <button className={style.playButton} onClick={onClick}>
        <Icon icon={'arrow-play-sm'} />
    </button>
));

export default PlayButton;
